import React from 'react';
import { Box, InputBase } from '@mui/material';
import { SearchOutlinedIcon } from 'icons/materialIcons';
import PropTypes from 'prop-types';

const SearchBar = ({ value, onChange, placeholder = "Search name, email or company" }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        backgroundColor: 'white',
        borderRadius: '20px',
        border: '1px solid #e3e3e3',
        padding: '8px 16px',
        marginBottom: 2,
        '&:hover': {
          boxShadow: 2,
        },
      }}
    >
      <SearchOutlinedIcon
        sx={{
          color: '#828282',
          fontSize: '18px',
          marginRight: '8px'
        }}
      />
      <InputBase
        fullWidth
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        sx={{
          fontSize: '0.7rem',
          color: '#4f4f4f',
          '& .MuiInputBase-input::placeholder': {
            color: '#828282',
            opacity: 1,
          },
        }}
      />
    </Box>
  );
};

SearchBar.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
};

export default SearchBar;